import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
//import { fetchDataCounts } from '../../Reducer/dataCountSlice';

const EditDataCount = ({ id, onClose, onSubmit }) => {
  //const dispatch = useDispatch();
  const dataCount = useSelector((state) =>
    state.dataCount.dataCounts.find((item) => item.id === id)
  );

  const [formData, setFormData] = useState({
    data_type: '',
    total_count: '',
    description: '',
    type: '',
    page: '', // Added page field to the initial state
  });

  useEffect(() => {
    if (dataCount) {
      setFormData(dataCount);
    }
  }, [dataCount]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(id, formData);
  };

  return (
    <div className="form-container">
      <h2>Edit Data Count</h2>
      <form onSubmit={handleSubmit} className="form">
        <input
          name="data_type"
          value={formData.data_type}
          onChange={handleInputChange}
          placeholder="Data Type"
          className="input-field"
          required
        />
        <input
          name="total_count"
          value={formData.total_count}
          onChange={handleInputChange}
          placeholder="Total Count"
          className="input-field"
          required
        />
        <input
          name="description"
          value={formData.description}
          onChange={handleInputChange}
          placeholder="Description"
          className="input-field"
          required
        />
        {/* Dropdown for page field */}
        <select
          name="page"
          value={formData.page}
          onChange={handleInputChange}
          className="input-field"
          required
        >
          <option value="" disabled>Select Page</option>
          <option value="home">Home</option>
          <option value="warrant">Warrant and criminals</option>
          <option value="global-sanctions">Global sanctions</option>
          <option value="pep">pep</option>
        </select>
        {/* Dropdown for type field */}
        <select
          name="type"
          value={formData.type}
          onChange={handleInputChange}
          className="input-field"
          required
        >
          <option value="" disabled>Select Type</option>
          <option value="consolidate">Consolidate</option>
          <option value="pep">PEP</option>
          <option value="warrant">Warrant</option>
        </select>
        <div className="form-actions">
          <button type="submit" className="submit-btn">Update Data Count</button>
          <button type="button" className="cancel-btn" onClick={onClose}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default EditDataCount;
